"use strict";
exports.__esModule = true;
exports.CREDIT_BUILDER_APPROVED_MODAL_CONTENT = void 0;
exports.CREDIT_BUILDER_APPROVED_MODAL_CONTENT = {
    HEADER: 'You’re approved!',
    BODY: 'You’ve officially been approved for a Flex credit line of {{creditLine}} to help boost your credit each month.',
    BULLETS_TITLE: 'Using your new credit line',
    BULLETS: [
        {
            LABEL: 'Fund your account.',
            BODY: 'Make a deposit equal to the amount of your rent bill.'
        },
        {
            LABEL: 'Flex pays rent.',
            BODY: 'We’ll pay your property using your credit line.'
        },
        {
            LABEL: 'Get a boost!',
            BODY: 'Paying rent with your credit line builds your credit.'
        },
    ],
    BOTTOM_TEXT: 'Set up your payment schedule in the next step to get started.',
    CTA: 'Continue'
};
